import { BasicQueryStringUtils, LocationLike } from '@openid/appauth';

/**
 * Prevent URI mismatch error by properly parsing URL query params
 * (See https://github.com/kdhttps/appauth-react/)
 */
export default class NoHashQueryStringUtils extends BasicQueryStringUtils {
  parse(input: LocationLike) {
    return super.parse(input, false /* never use hash */);
  }
}
